/**
 * The per-integration detail / OAuth screens, as one named group.
 *
 * Split out of App.tsx because that file is a route table sitting against the
 * repo's hard 500-line ceiling: every new integration used to cost it two
 * lines (an import and a route), so the next channel to ship would have been
 * the one that had to do this extraction under time pressure. Grouping them
 * here means adding a channel touches a file whose only job is channels.
 *
 * An ARRAY of Route elements, not a component: React Router builds its tree by
 * walking the children of the Routes element, and a component that returns
 * routes is opaque to that walk. An array is not — React.Children flattens it
 * — so these behave exactly as if they were written inline.
 *
 * Meta has no screen here on purpose: it is managed inline on the Integrations
 * page (MetaCard), and its old sub-page redirects so bookmarks and toast links
 * keep working.
 */
import { Suspense } from 'react';
import { Route } from 'react-router-dom';
import { LegacyRedirect } from '../routes/LegacyRedirect';
import { PageLoader } from './PageLoader';
import {
  ShopifySettings,
  TikTokSettings,
  LinkedInSettings,
  YouTubeSettings,
  XSettings,
  HubSpotSettings,
  SalesforceSettings,
  GoogleSheetsSettings,
  GoogleAdsSettings,
  GmailSettings,
  TikTokAdsSettings,
} from './lazyRoutes';

/** Reached from the Account → Integrations tab's "Manage" button. */
export const integrationSettingsRoutes = [
  <Route
    key="shopify"
    path="/settings/integrations/shopify"
    element={
      <Suspense fallback={<PageLoader />}>
        <ShopifySettings />
      </Suspense>
    }
  />,
  <Route
    key="meta"
    path="/settings/integrations/meta"
    element={<LegacyRedirect to="/settings/integrations" />}
  />,
  <Route key="tiktok" path="/settings/integrations/tiktok" element={<TikTokSettings />} />,
  <Route key="linkedin" path="/settings/integrations/linkedin" element={<LinkedInSettings />} />,
  <Route key="youtube" path="/settings/integrations/youtube" element={<YouTubeSettings />} />,
  <Route key="x" path="/settings/integrations/x" element={<XSettings />} />,
  <Route key="hubspot" path="/settings/integrations/hubspot" element={<HubSpotSettings />} />,
  <Route
    key="salesforce"
    path="/settings/integrations/salesforce"
    element={<SalesforceSettings />}
  />,
  <Route
    key="google-sheets"
    path="/settings/integrations/google-sheets"
    element={<GoogleSheetsSettings />}
  />,
  <Route
    key="google-ads"
    path="/settings/integrations/google-ads"
    element={<GoogleAdsSettings />}
  />,
  <Route
    key="gmail"
    path="/settings/integrations/gmail"
    element={<GmailSettings />}
  />,
  <Route
    key="tiktok-ads"
    path="/settings/integrations/tiktok-ads"
    element={<TikTokAdsSettings />}
  />,
];
